import React, {Component} from "react";

export default class rightCaret extends Component{
    render() {
        const {color, width, height} = this.props;
        return (
            <svg width={width} height={height} viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.625 1.48231L8.76314 9L0.625 16.5177L0.625 1.48231Z" stroke={color}/>
            </svg>
        )
    }
}
